import script from "./OrderInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderInfo.vue?vue&type=script&setup=true&lang=js"

import "./OrderInfo.vue?vue&type=style&index=0&id=0508ef8d&lang=scss&scoped=true"

import exportComponent from "/home/ecs-user/software/jenkins/workspace/smallshop-website-uat/smallshop-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0508ef8d"]])

export default __exports__